// TODO: to be refactored and moved to .env
export const GOOGLE_MAPS_API_KEY = 'AIzaSyBIhM2f75UrV0oktwtQZ4_Tj1MNycLSPRE';